<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="故障名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.name"
              placeholder="请输入故障名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="添加时间：">
            <el-date-picker
              v-model="createTimeBetween"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              unlink-panels
              @change="handleSearchListData"
              clearable
            ></el-date-picker>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          @click="handleAdd('')"
          class="plr28"
          >添加</el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="treeList"
          max-height="400"
          border
          ref="multipleTable"
          row-key="id"
          style="width: 100%"
          :tree-props="{ children: 'childrenList' }"
        >
          >
          <!-- <el-table-column show-overflow-tooltip prop="targetDate" label="月份" width="120"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="name"
            fixed
            width="120"
            label="名称"
          ></el-table-column>
          <el-table-column
            prop="faultReasonName"
            label="故障原因"
            width="240"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="templateName"
            label="模板名称"
            width="240"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="添加时间"
            width="100"
          >
            <template slot-scope="scope">
              {{
                scope.row.createTime ? scope.row.createTime.slice(0, 10) : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注信息"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column label=" "></el-table-column> -->
          <el-table-column label="操作" width="148px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                class="plr28"
                @click="handleAdd(scope.row)"
                >添加</el-button
              >
              <div class="btn-divide"></div>
              <el-button size="mini" type="text" @click="editFault(scope.row)"
                >编辑</el-button
              >
              <div class="btn-divide"></div>
              <el-button type="text" size="mini" @click="deletePoint(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <edit-fault
      :unitId="faultDetail.unitId"
      :editData="faultDetail"
      v-if="showEditFault"
      @confirm="editFaultConfirm"
      @cancel="showEditFault = false"
    ></edit-fault>
    <add-fault
      v-if="addFaultVisible"
      :editData="faultDetail"
      @confirm="handleAddFaultConfirm"
      @cancel="addFaultVisible = false"
    ></add-fault>
  </div>
</template>

<script>
import { getPointTree, deletePoint } from "@/api/FaultTypesItems";

import EditFault from "./components/EditFault";
import AddFault from "./components/AddFault";
export default {
  name: "FaultTypesItems",
  components: {
    EditFault,
    AddFault,
  },
  data() {
    return {
      form: {
        name: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addFaultVisible: false,
      editFaultVisible: false,
      checkFaultVisible: false,
      checkFault: false,
      faultDetail: {},
      treeList: [],
      showEditFault: false,
      createTimeBetween: null,
      templateId: ''
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.templateId = this.$route.query.templateId
    this.getListData();
  },
  methods: {
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      if (this.createTimeBetween && this.createTimeBetween.length) {
        params.endCreateTime = this.createTimeBetween[1];
        params.startCreateTime = this.createTimeBetween[0];
      }
      params.templateId = this.templateId
      const res = await getPointTree(params);
      if (res.code === 200) {
        this.treeList = res.data;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteFault(row) {
      const idList = [row.id];
      this.deletePoint(idList);
    },
    handleCheck(row) {
      this.faultDetail = row;
      this.checkFault = true;
    },
    handleEdit(row) {
      this.faultDetail = row;
      this.editFaultVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deletePoint(idList);
    },
    deletePoint(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deletePoint({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd(row) {
      this.faultDetail = row;
      this.addFaultVisible = true;
    },
    exportFault() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      params.templateId = this.templateId
      exportFault(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddFaultConfirm() {
      this.addFaultVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditFaultConfirm() {
      this.editFaultVisible = false;
      this.getListData();
    },
    editFault(row) {
      this.faultDetail = row;
      this.showEditFault = true;
    },
    deletePoint(row) {
      const idList = [row.id];
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deletePoint({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editFaultConfirm() {
      this.showEditFault = false;
      this.getListData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/FaultTypesItems/FaultTypesItems.vue